import React from "react";
import "./HeroContacto.css";

const HeroContacto = () => {
  return (
    <section className="hero-contacto">
      <div className="hero-contacto-overlay">
        <h1>Contactanos</h1>
        <h2>Estamos aquí para ayudarte. ¡Escribinos o vení a visitarnos!</h2>
      </div>
    </section>
  );
};

export default HeroContacto;
